module.exports = __webpack_public_path__ + "static/media/interior-view.13268a3f.png";